import React, { FC } from "react";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";

import { theme } from "./theme";

export const ThemeProvider: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>;
};
